import { Box, Stack, Typography } from '@mui/material';
import { COLOR_BG_BLACK_2 } from 'shared';
import HomeBg from 'shared/assets/video/home_background.webm';
import { CrowdsaleWidget } from 'widgets';

import { IntroCard, ScrollingText } from './ui';

export const Intro = () => {
  return (
    <Box component="section">
      <Stack alignItems="flex-start" direction={{ xs: 'column', md: 'row' }}>
        <Box position="relative">
          <Typography
            className="no-resize"
            variant="h1"
            sx={{
              maxWidth: { xs: '100%', sm: 615, md: 832 },
              fontSize: { xs: 32, sm: 44 },
              fontWeight: 500,
              letterSpacing: '-3%',
            }}
          >
            Powering the Future of Decentralized Commerce & Finance
          </Typography>
          <Typography
            variant="h5"
            maxWidth={{ xs: 290, sm: 548 }}
            className="no-resize regular"
            fontSize={{ xs: 14, sm: 20 }}
            lineHeight={{ xs: '24px', sm: '32px' }}
            mt={{ xs: 1.5, sm: 4 }}
            mb={{ xs: 3, sm: 7 }}
          >
            Experience unmatched speed, security, and global scalability with CratD2C&#39;s Layer-1 DPoS Blockchain.
          </Typography>

          <Box display={{ xs: 'none', md: 'block' }}>
            <IntroCard />
            <ScrollingText />
          </Box>
        </Box>
        {/* <CrowdsaleWidget /> */}
      </Stack>
      <Box mt={3} display={{ xs: 'block', md: 'none' }}>
        <IntroCard />
        <ScrollingText />
      </Box>
      <Box
        component="video"
        autoPlay
        muted
        loop
        playsInline
        sx={{
          objectFit: 'cover',
          position: 'absolute',
          zIndex: -2,
          top: 0,
          height: { xs: 700, md: 1434 },
          left: 0,
          width: '100vw',
          overflow: 'hidden',
        }}
      >
        <source src={HomeBg} type="video/webm" />
      </Box>
      <Box
        sx={{
          background: `linear-gradient(transparent 10%, ${COLOR_BG_BLACK_2})`,
          objectFit: 'cover',
          position: 'absolute',
          zIndex: -1,
          top: 0,
          height: { xs: 700, md: 1434 },
          left: { xs: -150, md: 0 },
          width: { xs: 'calc(100vw + 150px)', md: '100vw' },
          overflow: 'hidden',
        }}
      />
    </Box>
  );
};
